import React from 'react';
import { bandLabel, scoreBand, type Bands } from '../../utils/scoring';
interface AiScoreGaugeProps {
  score: number;
  bands?: Bands;
  caption?: string;
}
export function AiScoreGauge({
  score,
  bands,
  caption
}: AiScoreGaugeProps) {
  const band = scoreBand(score, bands);
  const radius = 42;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - Math.min(score, 100) / 100 * circumference;
  const stroke = band === 'auto-advance' ? '#4bbd90' : band === 'manual-review' ? '#e0b52f' : '#e56b68';
  return <div className="flex items-center gap-4" data-id="element-99" data-mp="3jda7o3h8impn">
      <div className="relative h-[104px] w-[104px] shrink-0" data-id="element-100" data-mp="3els73gj4io57">
        <svg viewBox="0 0 100 100" className="h-full w-full -rotate-90" aria-hidden="true" data-id="element-101" data-mp="3ek7f9yo71jb1">
          <circle cx="50" cy="50" r={radius} fill="none" stroke="rgba(255,255,255,0.14)" strokeWidth="8" data-id="element-102" data-mp="39mp0hrnhw9v4" />
          <circle cx="50" cy="50" r={radius} fill="none" stroke={stroke} strokeWidth="8" strokeDasharray={circumference} strokeDashoffset={offset} strokeLinecap="round" data-id="element-103" data-mp="ay9tmdetxekx" />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-104" data-mp="376v07bdfd71b">
          <span className="font-mono text-xl font-semibold text-white" data-id="element-105" data-mp="2tcu830gzai9x">{score.toFixed(1)}</span>
          <span className="text-[10px] uppercase tracking-[0.1em] text-white/50" data-id="element-106" data-mp="2yavtvt5sgvp3">/ 100</span>
        </div>
      </div>
      <div className="min-w-0" data-id="element-107" data-mp="2jhaievt0cftm">
        <p className="text-[11px] uppercase tracking-[0.1em] text-white/50" data-id="element-108" data-mp="2oe0sn2i4sh74">Weighted AI score</p>
        <p className="mt-1 text-sm font-medium text-white" data-id="element-109" data-mp="2aergcdx1q78f">{bandLabel(band)}</p>
        {caption && <p className="mt-1.5 text-[11px] leading-relaxed text-white/60" data-id="element-110" data-mp="2fd2p0lblubp2">{caption}</p>}
      </div>
    </div>;
}